import { useMutation, useQuery } from "@tanstack/react-query";
import { getNavigate } from "../pages/Navigation/Navigation";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";

export async function fetchClient(url, options = {}) {
  const { method = "GET", body, data, params, headers = {}, isFormData, ...rest } = options;
  const requestOptions = {
    method,
    headers: {
      ...headers,
    },
    credentials: "include",
    ...rest,
  };
  if (isFormData) {
    requestOptions.body = data;
  } else {
    requestOptions.headers["Content-Type"] = "application/json";
    if (body || data) {
      requestOptions.body = JSON.stringify(body || data);
    }
  }

  if (params) {
    const urlParams = new URLSearchParams(params).toString();
    url = `${url}?${urlParams}`;
  }

  try {
    const res = await fetch(`${process.env.REACT_APP_API_URL}${url}`, requestOptions);

    if (res.status === 401) {
      try {
        const navigate = getNavigate();
        toast.error("Unauthorized. Try again.");
        navigate("/login");
      } catch (err) {
        console.warn("Navigate not set yet, skipping redirect");
      }
      const error = new Error("Unauthorized");
      error.status = 401;
      throw error;
    }

    if (!res.ok) {
      const errorBody = await res.json().catch(() => ({}));
      const error = new Error(errorBody?.message || "Something went wrong");
      error.status = res.status;
      throw error;
    }
    const json = await res.json();
    return json;
  } catch (error) {
    if (error.name === "AbortError") {
      throw new Error("Request was aborted");
    }
    throw error;
  }
}

export const useAppQuery = ({
  queryKey,
  url,
  method = "GET",
  isFormData,
  data = null,
  options = {},
  enabled = true,
}) => {
  return useQuery({
    queryKey,
    queryFn: () => fetchClient(url, { method, data, isFormData }),
    retry: false,
    refetchOnWindowFocus: false,
    staleTime: 2 * 60 * 1000,
    cacheTime: 2 * 60 * 1000,
    enabled: enabled,
    onError: (error) => {
      const navigate = getNavigate();
      if (error.status === 401) {
        navigate("/login");
      }
    },

    ...options,
  });
};
export const useAppMutation = () => {
  return useMutation({
    mutationFn: ({ url, method = "POST", data, isFormData = false }) => fetchClient(url, { method, data, isFormData }),
    retry: false,
    onError: (error) => {
      const navigate = getNavigate();
      console.error("Mutation Error:", error);
      if (error.status === 401) {
        navigate("/login");
      }
    },
  });
};
